<!------------ START TEMPLATE ------------>
<template>
  <div>
    <!------------ START FORM ------------>
    <form role="form" @submit.stop.prevent="onSubmit">
      <!-----============================ OBS: No status deve ter um campo SELECT que irá trazer as opções criadas pelo usuário na parte cadastro de Status do Menu USUARIO  ==================------->
      <vs-alert
        v-if="$validator.errors.all().length > 0"
        color="danger"
        title="Atenção!!"
        active="true"
        class="my-3"
        style="height: auto !important"
      >
        <ul>
          <li
            class="mb-2"
            v-for="error in $validator.errors.all()"
            :key="error.id"
          >
            {{ error }}
          </li>
        </ul>
      </vs-alert>
      <div class="vx-row mb-6 mt-6">
        <div class="vx-col sm:w-1/1 w-full">
          <span>Evento</span>
          <v-select
            :options="domEventosMensageria"
            name="Evento"
            id="Evento"
            label="evento"
            :disabled="formCadastro.idPadrao ? true : false"
            v-model="formCadastro.idEventoMensageria"
            @input="preencheTemplate"
            :reduce="(Evento) => Evento.idEventoMensageria"
            v-validate="{ required: true }"
            :state="
              utilsList.validateState(this.veeFields, this.veeErrors, 'Evento')
            "
            :class="
              utilsList.validateStateClass(
                this.veeFields,
                this.veeErrors,
                'Evento'
              )
            "
          />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/1 w-full">
          <span>Tipo</span>
          <v-select
            :options="tipo"
            name="Tipo"
            id="Tipo"
            v-model="formCadastro.tipo"
            :disabled="formCadastro.idPadrao ? true : false"
            v-validate="{ required: true }"
            @input="preencheTemplate"
            :state="
              utilsList.validateState(this.veeFields, this.veeErrors, 'Tipo')
            "
            :class="
              utilsList.validateStateClass(
                this.veeFields,
                this.veeErrors,
                'Tipo'
              )
            "
          />
        </div>
      </div>
      <vx-card v-if="formCadastro.tipo && formCadastro.idEventoMensageria">
        <h5 class="mb-4">Template</h5>

        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/1 w-full">
            <vs-input
              class="w-full"
              label="Assunto"
              v-model="formCadastro.assunto"
              name="Assunto"
              v-validate="{ required: false }"
              :state="validateState('Assunto')"
              :danger="validateClass('Assunto')"
            />
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/1 w-full">
            <label for="" class="vs-input--label">Padrão</label>
            <vs-textarea
              class="w-full"
              name="Padrão"
              id="Padrão"
              v-model="formCadastro.padrao"
              :state="validateState('Padrão')"
              :danger="validateClass('Padrão')"
              val-icon-danger="clear"
              danger-text="Preencha este Campo"
              icon-no-border
              rows="10"
            />
            Variáveis Disponíveis:{{ formCadastro.variaveis }}
          </div>
        </div>
      </vx-card>

      <div class="vx-row mt-5">
        <div class="vx-col w-full text-right">
          <vs-button color="success" class="mr-3 mb-2">{{
            formCadastro.idPadrao ? "Atualizar" : "Adicionar"
          }}</vs-button>
        </div>
      </div>
    </form>
    <!------------ END FORM ------------>
  </div>
</template>
<!------------ END TEMPLATE ------------>

<!------------ START SCRIPT ------------>
<script>
import locale from "../../../../locale";
import Datepicker from "vuejs-datepicker";
import * as lang from "vuejs-datepicker/src/locale";
import vSelect from "vue-select";
import service from "../../../../services";
import utilsList from "../../../../utils/list";
import { Money } from "v-money";
export default {
  props: ["idDistribuidor", "objUpdate"],
  watch: {
    objUpdate(value) {
      console.log("Chamou o preencher");
      this.preencheForm();
    },
  },
  data() {
    return {
      money: {
        decimal: ".",
        thousands: "",
        prefix: "",
        suffix: "",
        precision: 2,
      },
      utilsList,
      aguardeCadastro: false,
      languages: lang,
      funcoesValicao: null,
      domEventosMensageria: [],
      tipo: ["E-mail", "SMS"],
      formCadastro: {
        idPadrao: null,
        idEventoMensageria: null,
        idDistribuidor: null,
        tipo: null,
        assunto: null,
        padrao: null,
      },
    };
  },
  methods: {
    preencheForm() {
      if (this.objUpdate) {
        console.log(this.objUpdate);
        this.formCadastro.idPadrao = this.objUpdate.idPadrao;
        this.formCadastro.idEventoMensageria =
          this.objUpdate.idEventoMensageria;
        this.formCadastro.idDistribuidor = this.idDistribuidor;
        this.formCadastro.tipo = this.objUpdate.tipo;
        this.formCadastro.assunto = this.objUpdate.assunto;
        this.formCadastro.padrao = this.objUpdate.padrao;
      }
    },
    limpaForm() {
      if (!this.objUpdate) {
        this.formCadastro = {
          idPadrao: null,
          idEventoMensageria: null,
          idDistribuidor: null,
          tipo: null,
          assunto: null,
          padrao: null,
        };
      }
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },
    preencheTemplate() {
      console.log(this.domEventosMensageria);
      if (this.formCadastro.idEventoMensageria && this.formCadastro.tipo) {
        console.log(this.formCadastro.idEventoMensageria);
        console.log(this.formCadastro.tipo);
        var aux = this.domEventosMensageria.find(
          (x) => x.idEventoMensageria == this.formCadastro.idEventoMensageria
        );
        this.formCadastro.assunto = aux.assuntoPadrao;
        if (this.formCadastro.tipo == "E-mail") {
          this.formCadastro.padrao = aux.emailPadrao;
        } else {
          this.formCadastro.padrao = aux.smsPadrao;
        }
        this.formCadastro.variaveis = aux.variaveisDisponiveis;
      }
    },
    buscaDomEventosMensageria() {
      this.popUpdate = false;
      this.objUpdate = null;

      this.$vs.loading();
      service
        .getAll("g", {}, "domEventosMensageria/list")
        .then((res) => {
          if (res.data.length > 0) {
            console.log(res.data);
            this.domEventosMensageria = [];
            res.data.forEach((element) => {
              this.domEventosMensageria.push(element);
            });
            //this.maquinaStatus = res.data;
            this.$vs.loading.close();
          } else {
            this.$vs.loading.close();
          }
          this.$forceUpdate();
        })
        .catch((e) => {
          this.$vs.notify({
            position: "top-center",
            title: "Atenção",
            text: e,
            color: "danger",
          });
          this.$vs.loading.close();
        });
    },

    onSubmit() {
      this.formCadastro.idDistribuidor = this.idDistribuidor;

      var action = this.formCadastro.idPadrao
        ? "Atualizar/" + this.formCadastro.idPadrao
        : "Adicionar";

      var metodo = this.formCadastro.idPadrao ? "put" : "post";

      console.log(this.formCadastro);
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.aguardeCadastro = true;
          service[metodo](
            "DistribuidorPadraoMensageria",
            action,
            this.formCadastro
          )
            .then((res) => {
              this.aguardeCadastro = false;
              this.$vs.notify({
                position: "top-center",
                title: "Atenção",
                text: `Operação Realizada com sucesso`,
                color: "success",
              });
              this.formCadastro = {
                idPadrao: null,
                idEventoMensageria: null,
                idDistribuidor: null,
                tipo: null,
                assunto: null,
                padrao: null,
              };
              console.log("Vai Emitr");
              this.$emit("add", res.data);
            })
            .catch((error) => {
              this.aguardeCadastro = false;
              this.$vs.notify({
                position: "top-center",
                title: "Atenção",
                text: error,
                color: "danger",
              });
            });
        }
      });
    },
  },
  mounted() {
    this.$validator.localize("ptBr", locale);
    this.buscaDomEventosMensageria();
  },
  components: {
    Datepicker,
    "v-select": vSelect,
    Money,
  },
};
</script>
<!------------ END SCRIPT ------------>
<style scoped>
.vs-con-textarea {
  border: 1px solid rgba(0, 0, 0, 0.2) !important;
}
</style>
